import React from "react"
import {Application, cancelApplication, getApplicationName} from "../../resources/application"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useAccessToken} from "../../services/auth"
import {CancelApplicationModal} from "./ApplicationCancel"

interface OnboardingCancelModalProps {
	application: Application
	close: () => void
	onSuccess: () => void
}

export function CancelOnboardingApplicationModal({application, close, onSuccess}: OnboardingCancelModalProps) {
	const accessToken = useAccessToken()
	const [state, cancel] = useAsyncResultIdle(cancelApplication)

	return (
		<CancelApplicationModal
			title={`Cancel Application for ${getApplicationName(application)}`}
			close={close}
			onSuccess={onSuccess}
			cancelFn={(token, reason) => cancel(token, application, reason)}
			state={state}
			accessToken={accessToken}
			warningMessage="Canceling an application cannot be undone. To become a customer, a new application will have to be created."
		/>
	)
}
